export default {
  DOMAIN_URL: 'https://sxfn79gl5i.execute-api.ap-northeast-1.amazonaws.com/dev'
}
